module.exports = __webpack_public_path__ + "img/hr-tree-04-a-leaves.d69c1252.png";